import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/auth/AuthContext";
import HomePage from "@/pages/HomePage";
import PortfolioHub from "@/pages/PortfolioHub";
import PortfolioCategory from "@/pages/PortfolioCategory";
import PortfolioItem from "@/pages/PortfolioItem";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminWork from "@/pages/admin/AdminWork";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminItemForm from "@/pages/admin/AdminItemForm";
import AdminBulk from "@/pages/admin/AdminBulk";
import AdminFeatured from "@/pages/admin/AdminFeatured";
import AdminAwards from "@/pages/admin/AdminAwards";
import AdminClients from "@/pages/admin/AdminClients";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/portfolio" element={<PortfolioHub />} />
          <Route path="/portfolio/:categorySlug" element={<PortfolioCategory />} />
          <Route path="/portfolio/:categorySlug/:itemSlug" element={<PortfolioItem />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminWork />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="work/new" element={<AdminItemForm />} />
            <Route path="work/:id/edit" element={<AdminItemForm />} />
            <Route path="bulk" element={<AdminBulk />} />
            <Route path="featured" element={<AdminFeatured />} />
            <Route path="awards" element={<AdminAwards />} />
            <Route path="clients" element={<AdminClients />} />
          </Route>
        </Routes>
        <Toaster
          position="bottom-right"
          toastOptions={{ style: { background: "#121316", color: "#F9F8F6", border: "1px solid rgba(249,248,246,0.15)" } }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}
